import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../../web/ReactQueryProvider';
import { timeEntryKeys } from './keys';
import { ITimeEntry, ITimeEntryFilter, ITimeEntryPage } from './types';

export function useTimeEntryFilterQuery({ filter, enabled = true }: { filter: ITimeEntryFilter; enabled?: boolean }) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: timeEntryKeys.filter(filter),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<ITimeEntryPage<ITimeEntry>>('TimeEntry/filter', 'POST', filter),
		enabled,
		meta: {
			toastErrorMessage: 'Failed to load hours',
			errorLogging: { action: 'TimeEntryFilterQuery-Error', category: 'TimeEntry' },
		} satisfies LevStandardQueryMeta,
	});
}
